import { ky } from './ky';

export type ResourceType = 'FEED' | 'PLACE' | 'ACCOUNT' | 'HASHTAG';

export interface ShortLinkResponse {
  linkId: string;
  resourceType: ResourceType;
  resourceId: string;
}

export interface ResolveShortLinkResponse {
  linkId: string;
  url: string;
}

export default class ShortLinkService {

  /**
   * 단축 링크 생성
   */
  async create(resourceType: ResourceType, resourceId: string): Promise<ShortLinkResponse> {
    const response = await ky.post('v1/short-links', {
      json: { resourceType, resourceId },
    });
    return await response.json() as ShortLinkResponse;
  }

  /**
   * 단축 링크 resolve
   */
  async resolve(linkId: string): Promise<ResolveShortLinkResponse> {
    const response = await ky.get(`v1/short-links/${linkId}`);
    return await response.json() as ResolveShortLinkResponse;
  }
}
